import type { FilterNotEndWith, Locales, ServerConfig } from 'shared-types';

export type NavSection = FilterNotEndWith<
  keyof ServerConfig['navLinksCustomTexts'],
  'Translations'
>;

interface Params {
  defaultTitle: string;
  language: Locales;
  navLinksCustomTexts: ServerConfig['navLinksCustomTexts'];
  section: NavSection;
}

const getCustomizedNavTitle = ({
  defaultTitle,
  language,
  navLinksCustomTexts,
  section
}: Params) => {
  const customText = navLinksCustomTexts?.[section];
  const customTextTranslation =
    navLinksCustomTexts?.[`${section}Translations`]?.[language];

  return customTextTranslation || customText || defaultTitle;
};

export default getCustomizedNavTitle;
